import { render, staticRenderFns } from "./LineProfileRegist.vue?vue&type=template&id=5821c40e"
import script from "./LineProfileRegist.vue?vue&type=script&lang=js"
export * from "./LineProfileRegist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports